import { createApp } from 'vue';
import App from './App.vue';
// import VuePikaday from '@netcz/vue-pikaday';
// import '@netcz/vue-pikaday/dist/vue-pikaday.min.css';

const app = createApp(App);
// app.use(VuePikaday);
window['appVue']= app.mount('#app');
